import React from 'react'
import { useLocation, Link } from 'react-router-dom'
import { CBreadcrumb, CBreadcrumbItem } from '@coreui/react'

const DynamicBreadcrumb = () => {
  const location = useLocation()
  
  // Define route mappings
  const routeMap = {
    '/members/dashboard': 'Dashboard',
    '/members/profile': 'Profile',
    '/members/company-profile': 'Company Profile',
    '/members/my-profile': 'My Profile',
    '/members/membership': 'Membership',
    '/members/documents': 'Documents',
    '/members/notifications': 'Notifications',
  }

  // Generate breadcrumb items based on current path
  const generateBreadcrumbs = () => {
    const pathSegments = location.pathname.split('/').filter(segment => segment !== '')
    const breadcrumbs = []

    // Always start with Home
    breadcrumbs.push({
      label: 'Home',
      href: '/',
      active: false
    })

    // Build path progressively
    let currentPath = ''
    pathSegments.forEach((segment, index) => {
      currentPath += `/${segment}`
      
      // Skip the last segment as it will be the active item
      const isLast = index === pathSegments.length - 1
      const label = routeMap[currentPath] || segment.charAt(0).toUpperCase() + segment.slice(1)
      
      breadcrumbs.push({
        label,
        href: currentPath,
        active: isLast
      })
    })

    return breadcrumbs
  }

  const breadcrumbs = generateBreadcrumbs()

  return (
    <CBreadcrumb className="mb-0">
      {breadcrumbs.map((breadcrumb, index) => (
        <CBreadcrumbItem
          key={index}
          active={breadcrumb.active}
          className={breadcrumb.active ? 'text-secondary' : ''}
        >
          {breadcrumb.active ? (
            breadcrumb.label
          ) : (
            <Link 
              to={breadcrumb.href} 
              className="text-primary text-decoration-none"
            >
              {breadcrumb.label}
            </Link>
          )}
        </CBreadcrumbItem>
      ))}
    </CBreadcrumb>
  )
}

export default DynamicBreadcrumb 